export const devicePaths = {
  DEVICE: "",
  DEVICE_EDIT: ":id",
  DEVICE_ID: (id) => id,
  DEVICE_DELETE: "delete/:id",
  DEVICE_DELETE_ID: (id) => `delete/${id}`,
  PRINTER: "printer",
  PRINTER_EDIT: "printer/:id",
  PRINTER_ID: (id) => `printer/${id}`,
  PRINTER_CREATE: "printer/create",
};
